import dva from 'dva';
import { message } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { resolveRuntimeConfig } from './config/runtime.js';
import history from './history.js';
import models from './models/index.js';
import RouterConfig from './router.js';
import globalVars from './utils/global.js';
import './index.less';

moment.locale('zh-cn');
const ERROR_MESSAGE_DURATION_SECONDS = 3;

Object.assign(
  globalVars,
  resolveRuntimeConfig(window.location, window.__HXR_RUNTIME_CONFIG__ ?? {}),
);

const app = dva({
  history,
  onError(error: Error) {
    console.error(error);
    message.error(error.message, ERROR_MESSAGE_DURATION_SECONDS);
  },
});

for (const model of models) app.model(model);
app.router(RouterConfig);
app.start('#root');
